export default {
  methods: {
    convertTime(dt) {
      let time = new Date();
      time.setTime(Date.parse(dt.replace(' ', 'T') + "Z"));
      return time.toLocaleString("it-IT");
    },
  
    convertOnlyTime(dt) {
      let time = new Date();
      time.setTime(Date.parse(dt.replace(' ', 'T') + "Z"));
      return time.toLocaleTimeString("it-IT");
    },
  
    convertOnlyDate(dt) {
      let time = new Date();
      time.setTime(Date.parse(dt.replace(' ', 'T') + "Z"));
      return time.toLocaleDateString("it-IT");
    },
  
    fromTime2HtmlDate(time) {
      return time.getFullYear() + '-' + (time.getMonth() + 1).toString().padStart(2, "0") + '-' + time.getDate().toString().padStart(2, "0");
    },

    fromTime2HtmlTime(time) {
      return time.getHours().toString().padStart(2, "0") + ':' + time.getMinutes().toString().padStart(2, "0");
    },

    formatMeasure(value, decimals) {
      if(decimals == undefined) decimals = 1
      const factor = 10**decimals
      return Math.floor(value*factor)/factor;
    },

    radarNotAvailable() {
      return "Le immagini del radar di Fossalon non sono disponibili per problemi tecnici, è possibile consultare lo storico delle immagini";
    }
  }
};

